import Styles from './OperatorUserPage.module.css'
import Colors from 'Theme/Colors'
import { IFButton, IFFilter, IFSkeleton } from 'Components'
import { useRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import OperatorUserSelectors from 'Stores/OperatorUser/Selectors'
import OperatorUserActions from 'Stores/OperatorUser/Actions'
import { connect } from 'react-redux'
import RequestState from 'Enums/RequestState'
import {
  OperatorUserList,
  OperatorUsersInviteList,
  OperatorUserPageTabs,
} from 'Containers'
import InviteOperatorUserModal from './InviteOperatorUserModal'
import PropTypes from 'prop-types'
import AuthSelectors from 'Stores/Auth/Selectors'
import InfinityEnums from 'Enums/InfinityEnums'
import LoadingBar from 'react-top-loading-bar'
import { useLocation } from 'react-router-dom'

const OperatorUserPage = ({
  fetchOperatorUserList,
  fetchOperatorUserListRequestState,
  fetchInviteOperatorUserList,
  fetchInviteOperatorUserListRequestState,
  operatorUser,
  fetchOperatorUsersCount,
  fetchOperatorUsersCountRequestState,
  fetchOperatorUsersInvitationsCount,
  fetchOperatorUsersInvitationsCountRequestState,
  operatorUsersCount,
  operatorUsersInvitationsCount,
  operatorUsersFilters,
  clearInvitations,
  clearOperatorUsers,
  resetFilters,
}) => {
  const [progress, setProgress] = useState(0)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [firstLoad, setFirstLoad] = useState(true)
  const [tablesHeight, setTablesHeight] = useState(0)
  const operatorUsersTableRef = useRef(null)
  const invitationsTableRef = useRef(null)
  const operatorUsersFilterRef = useRef(null)
  const canEdit = operatorUser.permissions.includes(
    InfinityEnums.OperatorUserPermission.CAN_EDIT_OPERATOR_USER,
  )
  const canView = operatorUser.permissions.includes(
    InfinityEnums.OperatorUserPermission.CAN_VIEW_OPERATOR_USER,
  )

  const location = useLocation()

  useEffect(() => {
    clearOperatorUsers()
    resetFilters()
    operatorUsersFilterRef?.current?.clearFilter()
    return () => {
      clearOperatorUsers()
      resetFilters()
      operatorUsersFilterRef?.current?.clearFilter()
    }
  }, [])

  useEffect(() => {
    if (selectedTabIndex === 0 && canView) {
      clearOperatorUsers()
      fetchOperatorUserList(operatorUsersFilters, 0)
      fetchOperatorUsersCount(operatorUsersFilters)
    } else if (selectedTabIndex === 1 && canView) {
      resetFilters()
      operatorUsersFilterRef?.current?.clearFilter()
      clearInvitations()
      fetchInviteOperatorUserList(0)
      fetchOperatorUsersInvitationsCount()
    }
  }, [selectedTabIndex, canView])
  useEffect(() => {
    fetchOperatorUsersCount(operatorUsersFilters)

    fetchOperatorUsersInvitationsCount()
  }, [canView])
  useEffect(() => {
    if (location.state?.refresh) {
      setFirstLoad(true)
      clearOperatorUsers()
      clearInvitations()
      setSelectedTabIndex(0)
    }
  }, [location.state?.refresh])
  useEffect(() => {
    if (
      fetchOperatorUserListRequestState === RequestState.LOADING &&
      progress === 0
    )
      setProgress(progress + 10)
    if (
      (fetchOperatorUserListRequestState !== RequestState.LOADING &&
        fetchOperatorUserListRequestState !== RequestState.UNINITIALIZED &&
        fetchOperatorUserListRequestState !== RequestState.SUCCEEDED) ||
      fetchOperatorUserListRequestState === RequestState.SUCCEEDED
    )
      setProgress(100)
  }, [fetchOperatorUserListRequestState])
  useEffect(() => {
    if (
      (fetchOperatorUserListRequestState === RequestState.SUCCEEDED &&
        fetchOperatorUsersCountRequestState === RequestState.SUCCEEDED &&
        firstLoad) ||
      (fetchInviteOperatorUserListRequestState === RequestState.SUCCEEDED &&
        fetchOperatorUsersInvitationsCountRequestState ===
          RequestState.SUCCEEDED &&
        firstLoad)
    ) {
      setFirstLoad(false)
    }
  }, [
    fetchOperatorUserListRequestState,
    fetchOperatorUsersCountRequestState,
    fetchInviteOperatorUserListRequestState,
    fetchOperatorUsersInvitationsCountRequestState,
    firstLoad,
  ])

  const handleTabChange = (newValue) => {
    setSelectedTabIndex(newValue)
  }
  const shouldShowLoadingState = () => {
    return (
      fetchOperatorUserListRequestState === RequestState.LOADING ||
      fetchInviteOperatorUserListRequestState === RequestState.LOADING
    )
  }

  const InviteOperatorUserRef = useRef()
  const { t } = useTranslation()
  useEffect(() => {
    if (canView) {
      fetchOperatorUserList(operatorUsersFilters, 0)
      fetchInviteOperatorUserList(0)
    }
  }, [canView])
  useEffect(() => {
    const handleResize = (entries) => {
      if (entries[0]) {
        const { height } = entries[0].contentRect
        setTablesHeight(height)
      }
    }
    const resizeObserver = new ResizeObserver(handleResize)
    if (operatorUsersTableRef.current) {
      resizeObserver.observe(operatorUsersTableRef.current)
    }
    if (invitationsTableRef.current) {
      resizeObserver.observe(invitationsTableRef.current)
    }
    return () => {
      if (operatorUsersTableRef.current) {
        resizeObserver.unobserve(operatorUsersTableRef.current)
      }
      if (invitationsTableRef.current) {
        resizeObserver.unobserve(invitationsTableRef.current)
      }
    }
  })

  const handleFilterChange = (newFilter) => {
    clearOperatorUsers()
    fetchOperatorUserList(newFilter, 0)
    fetchOperatorUsersCount(newFilter)
  }

  return (
    <div className={Styles.Wrapper}>
      <LoadingBar
        color={Colors.primary}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />

      <div
        className={Styles.NotificationsContainer}
        style={{
          backgroundColor: Colors.white,
          borderColor: Colors.DividerColor,
        }}
      >
        <div className={Styles.TabButtonDiv}>
          <OperatorUserPageTabs
            onValueChange={handleTabChange}
            initialIndex={selectedTabIndex}
            isLoading={
              firstLoad &&
              (fetchInviteOperatorUserList === RequestState.LOADING ||
                fetchOperatorUserListRequestState === RequestState.LOADING)
            }
            OperatorUsersCount={operatorUsersCount}
            InvitationCount={operatorUsersInvitationsCount}
            fetchListRequestState={
              selectedTabIndex == 0
                ? fetchOperatorUserListRequestState
                : fetchInviteOperatorUserListRequestState
            }
          />

          {canView && (
            <div>
              {(firstLoad &&
                fetchOperatorUserListRequestState === RequestState.LOADING) ||
              (firstLoad &&
                fetchInviteOperatorUserListRequestState ===
                  RequestState.LOADING) ? (
                <IFSkeleton variant="text" width="100px" />
              ) : (
                <>
                  {canEdit && (
                    <IFButton
                      color={Colors.primary}
                      isFill={false}
                      isDead={shouldShowLoadingState()}
                      size="xsm"
                      isLoading={false}
                      text={`+ ${t('OperatorUserPageContainer.Invite')}`}
                      onClick={() => InviteOperatorUserRef.current.show()}
                      className={Styles.InviteButton}
                      loadSkeleton={
                        fetchOperatorUserListRequestState ===
                          RequestState.LOADING ||
                        fetchInviteOperatorUserListRequestState ===
                          RequestState.LOADING
                      }
                    />
                  )}
                </>
              )}
            </div>
          )}
        </div>
        {canView && selectedTabIndex === 0 && (
          <div className={Styles.AdminFilterDiv}>
            <IFFilter
              ref={operatorUsersFilterRef}
              onFilterChange={(newFilter) => handleFilterChange(newFilter)}
              filters={operatorUsersFilters}
              textFieldPlaceholder={t(
                'OperatorUserPageContainer.FilterPlaceholder',
              )}
              isLoading={
                firstLoad &&
                fetchOperatorUserListRequestState === RequestState.LOADING
              }
            />
          </div>
        )}

        {selectedTabIndex === 0 && canView && (
          <div className={Styles.Tables} ref={operatorUsersTableRef}>
            <OperatorUserList tablesHeight={tablesHeight} />
          </div>
        )}
        {selectedTabIndex === 1 && canView && (
          <div className={Styles.Tables} ref={invitationsTableRef}>
            <OperatorUsersInviteList tablesHeight={tablesHeight} />
          </div>
        )}
      </div>
      <InviteOperatorUserModal ref={InviteOperatorUserRef} />
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    fetchOperatorUserList: (filter, offset) =>
      dispatch(OperatorUserActions.fetchOperatorUserList(filter, offset)),
    fetchInviteOperatorUserList: (offset) =>
      dispatch(OperatorUserActions.fetchInviteOperatorUserList(offset)),
    fetchOperatorUsersCount: (filter) =>
      dispatch(OperatorUserActions.fetchOperatorUsersCount(filter)),
    fetchOperatorUsersInvitationsCount: () =>
      dispatch(OperatorUserActions.fetchOperatorUsersInvitationsCount()),
    clearInvitations: () => dispatch(OperatorUserActions.clearInvitations()),
    clearOperatorUsers: () =>
      dispatch(OperatorUserActions.clearOperatorUsers()),
    resetFilters: () => dispatch(OperatorUserActions.resetFilters()),
  }
}

const mapStateToProps = (state) => ({
  fetchOperatorUserListRequestState:
    OperatorUserSelectors.getFetchOperatorUserListRequestState(state),
  fetchInviteOperatorUserListRequestState:
    OperatorUserSelectors.getFetchInviteOperatorUserListRequestState(state),
  operatorUser: AuthSelectors.getOperatorUser(state),
  fetchOperatorUsersCountRequestState:
    OperatorUserSelectors.getFetchOperatorUsersCountRequestState(state),
  fetchOperatorUsersInvitationsCountRequestState:
    OperatorUserSelectors.getFetchOperatorUsersInvitationsCountRequestState(
      state,
    ),
  operatorUsersCount: OperatorUserSelectors.getOperatorUsersCount(state),
  operatorUsersInvitationsCount:
    OperatorUserSelectors.getOperatorUsersInvitationsCount(state),
  operatorUsersFilters: OperatorUserSelectors.getOperatorUsersFilters(state),
})

OperatorUserPage.propTypes = {
  fetchOperatorUserList: PropTypes.func,
  fetchOperatorUserListRequestState: PropTypes.number,
  fetchInviteOperatorUserList: PropTypes.func,
  fetchInviteOperatorUserListRequestState: PropTypes.number,
  operatorUser: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(OperatorUserPage)
